<div class="ocorrencias">

    <!-- Cabeçalho + filtros por situação -->
    <div class="ocorrencias-cabecalho">
        <div class="ocorrencias-titulo">
            <h4>Ocorrências</h4>
            <p class="ocorrencias-resumo">
                {{ contadores.TODAS }} {{ contadores.TODAS === 1 ? 'ocorrência' : 'ocorrências' }}
                · {{ totalEtapas }} {{ totalEtapas === 1 ? 'etapa de análise' : 'etapas de análise' }}
            </p>
        </div>

        <div class="ocorrencias-filtros" role="tablist" aria-label="Filtrar por situação">
            <button type="button"
                *ngFor="let f of filtrosDisponiveis"
                class="filtro"
                [class.filtro--ativo]="filtro === f.valor"
                [attr.data-situacao]="f.valor"
                [disabled]="f.valor !== 'TODAS' && contadores[f.valor] === 0"
                (click)="selecionarFiltro(f.valor)">
                <span class="filtro-ponto" *ngIf="f.valor !== 'TODAS'"></span>
                {{ f.rotulo }} <span class="filtro-qtde">{{ contadores[f.valor] }}</span>
            </button>
        </div>
    </div>

    <!-- Um card por ocorrência -->
    <div class="ocorrencia" *ngFor="let ocorrencia of ocorrenciasVisiveis"
        [attr.data-situacao]="situacaoResumo(ocorrencia)">

        <div class="ocorrencia-cabecalho">
            <div class="ocorrencia-identificacao">
                <span class="ocorrencia-numero">Ocorrência {{ ocorrencia.idOcorrencia }}</span>
                <span class="chip chip--neutro" *ngIf="ocorrencia.tipoRecursoEsperado === 'E'">Recurso por etapa</span>
                <span class="chip chip--neutro" *ngIf="ocorrencia.tipoRecursoEsperado === 'P'">Recurso por parecer</span>
            </div>

            <span class="chip" [attr.data-situacao]="situacaoResumo(ocorrencia)">
                <span class="chip-ponto"></span>
                <ng-container [ngSwitch]="situacaoResumo(ocorrencia)">
                    <ng-container *ngSwitchCase="'ATIVO'">
                        {{ ocorrencia.totalPorSituacao.ATIVO }}
                        {{ ocorrencia.totalPorSituacao.ATIVO === 1 ? 'etapa aguardando recurso' : 'etapas aguardando recurso' }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'ENVIADO'">
                        {{ ocorrencia.totalPorSituacao.ENVIADO }}
                        {{ ocorrencia.totalPorSituacao.ENVIADO === 1 ? 'reconsideração encaminhada' : 'reconsiderações encaminhadas' }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>Prazo de recurso expirado</ng-container>
                </ng-container>
            </span>
        </div>

        <table class="etapas">
            <thead>
                <tr>
                    <th class="col-etapa">Etapa</th>
                    <th class="col-situacao">Situação</th>
                    <th class="col-documentos">Documentos enviados para o Sistema de Análise de Processos</th>
                    <th class="col-acoes"><span class="sr-only">Ações</span></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let etapa of etapasVisiveis(ocorrencia)">
                    <tr class="etapa" [attr.data-situacao]="etapa.situacao">
                        <td class="col-etapa">{{ etapa.nomeEtapa }}</td>

                        <td class="col-situacao">
                            <span class="chip" [attr.data-situacao]="etapa.situacao" [ngSwitch]="etapa.situacao">
                                <ng-container *ngSwitchCase="'ATIVO'">Em recurso</ng-container>
                                <ng-container *ngSwitchCase="'ENVIADO'">Encaminhada</ng-container>
                                <ng-container *ngSwitchDefault>Expirada</ng-container>
                            </span>
                        </td>

                        <td class="col-documentos">
                            <ng-container *ngIf="etapa.situacao === 'ENVIADO'; else semDocumentos">
                                <a class="documento" *ngIf="etapa.justificativa"
                                    [href]="etapa.justificativa._links?.self?.href" target="_blank" rel="noopener">
                                    <em class="pi pi-file"></em> Justificativa
                                </a>
                                <button type="button" class="documento documento--botao" *ngIf="etapa.anexos.length > 0"
                                    (click)="alternarAnexos(etapa)"
                                    [attr.aria-expanded]="etapa.anexosAbertos">
                                    <em class="pi pi-paperclip"></em>
                                    {{ etapa.anexos.length }} {{ etapa.anexos.length === 1 ? 'anexo' : 'anexos' }}
                                    <em class="pi" [class.pi-chevron-down]="!etapa.anexosAbertos" [class.pi-chevron-up]="etapa.anexosAbertos"></em>
                                </button>
                                <span class="documento--vazio"
                                    *ngIf="etapa.documentosCarregados && !etapa.justificativa && etapa.anexos.length === 0">
                                    Nenhum documento
                                </span>
                            </ng-container>
                            <ng-template #semDocumentos>
                                <span class="documento--vazio">
                                    {{ etapa.situacao === 'ATIVO' ? 'Nenhum documento' : 'Nenhum recurso enviado' }}
                                </span>
                            </ng-template>
                        </td>

                        <td class="col-acoes">
                            <a class="btn btn-primary btn-sm" *ngIf="etapa.situacao === 'ATIVO'"
                                [routerLink]="['/recurso', 'ocorrencia', etapa.reconsideracao.id]"
                                (click)="preencherRecurso(etapa.reconsideracao)">
                                <em class="pi pi-pencil"></em> Preencher dados do recurso
                            </a>
                        </td>
                    </tr>

                    <!-- Lista de anexos, expansível -->
                    <tr class="etapa-anexos" *ngIf="etapa.anexosAbertos && etapa.anexos.length > 0">
                        <td class="etapa-anexos-recuo" colspan="2" aria-hidden="true"></td>
                        <td class="col-documentos" colspan="2">
                            <ul>
                                <li *ngFor="let anexo of etapa.anexos; let i = index">
                                    <a [href]="anexo._links?.self?.href" target="_blank" rel="noopener">
                                        <em class="pi pi-download"></em> {{ anexo.nmArquivo || 'Anexo ' + (i + 1) }}
                                    </a>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <!-- Pareceres da análise: linha do tempo carregada ao expandir -->
        <section class="pareceres" [class.pareceres--aberto]="ocorrencia.pareceresAbertos">
            <button type="button" class="pareceres-alternar"
                (click)="alternarPareceres(ocorrencia)"
                [attr.aria-expanded]="ocorrencia.pareceresAbertos"
                [attr.aria-controls]="'pareceres-' + ocorrencia.idOcorrencia">
                <span class="pareceres-icone"><em class="pi pi-file-pdf"></em></span>
                <span class="pareceres-texto">
                    <span class="pareceres-titulo">
                        Pareceres da análise disponibilizados
                        <span class="pareceres-qtde" *ngIf="ocorrencia.cargaPareceres === 'CARREGADO'">
                            {{ ocorrencia.pareceres.length }}
                        </span>
                    </span>
                    <span class="pareceres-subtitulo">
                        {{ ocorrencia.pareceresAbertos
                            ? 'Documentos emitidos em cada etapa da análise'
                            : 'Clique para ver os documentos emitidos em cada etapa da análise' }}
                    </span>
                </span>
                <span class="pareceres-acao">
                    {{ ocorrencia.pareceresAbertos ? 'Ocultar' : 'Ver documentos' }}
                    <em class="pi" [class.pi-chevron-down]="!ocorrencia.pareceresAbertos"
                        [class.pi-chevron-up]="ocorrencia.pareceresAbertos"></em>
                </span>
            </button>

            <div class="pareceres-conteudo" *ngIf="ocorrencia.pareceresAbertos"
                [id]="'pareceres-' + ocorrencia.idOcorrencia" [ngSwitch]="ocorrencia.cargaPareceres">

                <ol class="linha-tempo linha-tempo--carregando" *ngSwitchCase="'CARREGANDO'" aria-busy="true">
                    <li class="linha-tempo-item" *ngFor="let i of [1, 2, 3]">
                        <span class="linha-tempo-marcador"></span>
                        <div class="linha-tempo-cartao">
                            <span class="esqueleto esqueleto--curto"></span>
                            <span class="esqueleto"></span>
                        </div>
                    </li>
                </ol>

                <div class="pareceres-aviso pareceres-aviso--erro" *ngSwitchCase="'ERRO'">
                    <em class="pi pi-exclamation-triangle"></em>
                    <span>Não foi possível carregar os pareceres.</span>
                    <button type="button" class="btn btn-link btn-sm" (click)="carregarPareceres(ocorrencia)">
                        Tentar novamente
                    </button>
                </div>

                <ng-container *ngSwitchCase="'CARREGADO'">
                    <div class="pareceres-aviso" *ngIf="ocorrencia.pareceres.length === 0">
                        <em class="pi pi-inbox"></em>
                        <span>Nenhum parecer emitido até o momento.</span>
                    </div>

                    <ol class="linha-tempo" *ngIf="ocorrencia.pareceres.length > 0">
                        <li class="linha-tempo-item" *ngFor="let parecer of ocorrencia.pareceres">
                            <span class="linha-tempo-marcador"></span>
                            <div class="linha-tempo-cartao">
                                <div class="linha-tempo-cabecalho">
                                    <span class="linha-tempo-etapa">{{ parecer.nomeEtapa || 'Etapa não informada' }}</span>
                                    <time class="linha-tempo-data" *ngIf="parecer.dataHoraAnexacao"
                                        [attr.datetime]="parecer.dataHoraAnexacao">
                                        <em class="pi pi-calendar"></em>
                                        {{ parecer.dataHoraAnexacao | date: 'dd/MM/yyyy HH:mm' }}
                                    </time>
                                </div>
                                <div class="linha-tempo-documento">
                                    <span class="linha-tempo-arquivo" [title]="parecer.nmArquivo">
                                        <em class="pi pi-file-pdf"></em>
                                        <span>{{ parecer.nmArquivo }}</span>
                                    </span>
                                    <button type="button" class="btn btn-default btn-sm"
                                        (click)="downloadDocumentoParecer(parecer)"
                                        [disabled]="parecerBaixando !== null"
                                        [attr.aria-label]="'Baixar ' + parecer.nmArquivo">
                                        <em class="pi" [class.pi-download]="parecerBaixando !== parecer.id"
                                            [class.pi-spin]="parecerBaixando === parecer.id"
                                            [class.pi-spinner]="parecerBaixando === parecer.id"></em>
                                        Baixar
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ol>
                </ng-container>
            </div>
        </section>
    </div>

    <p class="ocorrencias-vazio" *ngIf="ocorrenciasVisiveis.length === 0">
        Nenhuma ocorrência nesta situação.
    </p>
</div>
